import { ROUTE_PATHS } from '@constants/routing'

// import PartnersDocuments from './PartnersDocuments'
import { Link } from 'react-router-dom'

import './Partners.css'

const tabs = [
    {
        label: 'Documents',
        comment: 'Annotate deed, lease, etc. documents with labels like grantor & grantee',
        url: ROUTE_PATHS.PARTNERS_DOCUMENTS,
    },
    {
        label: 'Checks',
        comment: 'Annotate checks for organizations, labeling transactions & summing totals',
        url: ROUTE_PATHS.PARTNERS_CHECKS,
    },
].map((it, i) => ({
    id: i + 1,
    ...it,
}))

const Partners = () => {
    
    return (
        
        <div className="Partners">
            
            <div className="flex flex-col items-center content-center justify-center w-full">
                
                <h2 className="text-center banner">
                    Partner Annotations Portal
                </h2>
                
                <div className="flex items-center content-center justify-center gap-4 mt-4 text-center">
                    {tabs.map(it => (
                        <Link
                            key={`portal-link-${it.id}`}
                            className="px-4 portal-link"
                            to={it.url}>
                            <h4 className="mb-3 text-xl">{it.label}</h4>
                            <p>{it.comment}</p>
                        </Link>
                    ))}
                </div>
            
            </div>
        
        </div>
        
    )
    
}

export default Partners
